import React from 'react';
import { motion } from 'framer-motion';
import { ShieldAlert, Network, Search, Verified, ArrowRight } from 'lucide-react';

const OsintUseCases = () => {
  // Fonction de scroll fluide vers le CTA
  const scrollToCTA = () => {
    const ctaElement = document.getElementById('ctaOsint');
    if (ctaElement) {
      ctaElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const useCases = [
    {
      title: "Veille cyber",
      icon: <ShieldAlert size={18} strokeWidth={1.5} className="text-blue-600" />,
      description: "Surveillance proactive des informations publiques pour anticiper les menaces potentielles.",
    },
    {
      title: "Analyse de surface",
      icon: <Network size={18} strokeWidth={1.5} className="text-blue-600" />,
      description: "Identification exhaustive de vos actifs numériques pour réduire les vecteurs d'exposition.",
    },
    {
      title: "Investigation",
      icon: <Search size={18} strokeWidth={1.5} className="text-blue-600" />,
      description: "Analyse approfondie d'informations ouvertes pour vos besoins d'enquête numérique.",
    },
    {
      title: "Protection marque",
      icon: <Verified size={18} strokeWidth={1.5} className="text-blue-600" />,
      description: "Détection précoce d'usurpation d'identité et de fraude à l'image de marque.",
    }
  ];

  const springTransition = {
    type: "spring",
    stiffness: 100,
    damping: 18,
    mass: 1
  };

  return (
    <section className="relative w-full bg-[#f4f7fa] flex flex-col items-center" style={{ padding: '60px 24px' }}>
      
      {/* Header Section */}
      <div className="relative z-10 w-full max-w-[1080px] mb-10 text-left">
        
        <motion.p
          initial={{ opacity: 0, x: -15 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ ...springTransition, delay: 0.1 }}
          style={{ 
            color: '#3b82f6', 
            fontSize: '11px', 
            fontWeight: 700, 
            textTransform: 'uppercase', 
            letterSpacing: '0.05em',
            marginBottom: '8px' 
          }}
        >
          EXPERTISE & INNOVATION
        </motion.p>

        <motion.h2 
          initial={{ opacity: 0, x: -15 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={springTransition}
          style={{ fontSize: '32px', fontWeight: 900, color: '#0f172a', letterSpacing: '-0.03em', marginBottom: '14px', lineHeight: 1.05 }}
        >
          Cas d’usage de l’OSINT
        </motion.h2>

        <motion.p 
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="max-w-[550px]"
          style={{ fontSize: '14px', color: '#64748b', lineHeight: 1.55 }}
        >
          Découvrez comment nos solutions de renseignement en sources ouvertes renforcent votre sécurité numérique et protègent vos actifs stratégiques.
        </motion.p>
      </div>

      {/* Cards Grid */}
      <motion.div 
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
        variants={{
          hidden: { opacity: 0 },
          show: {
            opacity: 1,
            transition: { staggerChildren: 0.12 }
          }
        }}
        className="relative z-10 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 max-w-[1080px] w-full"
      >
        {useCases.map((useCase, idx) => (
          <motion.div
            key={idx}
            variants={{
              hidden: { opacity: 0, y: 20 },
              show: { opacity: 1, y: 0, transition: springTransition }
            }}
            whileHover={{ y: -6, transition: { duration: 0.2 } }}
            onClick={scrollToCTA}
            className="group p-6 rounded-2xl bg-white border border-slate-100/70 flex flex-col items-start transition-all duration-300 cursor-pointer"
          >
            <div className="bg-[#eef5ff] p-2.5 rounded-xl border border-slate-100/50 mb-5 text-blue-600 transition-colors duration-300 group-hover:bg-blue-100">
              {useCase.icon}
            </div>

            <h3 style={{ color: '#0f172a', fontSize: '16px', fontWeight: 800, marginBottom: '10px', letterSpacing: '-0.01em' }}>
              {useCase.title}
            </h3>

            <div className="flex-grow">
              <p style={{ color: '#64748b', fontSize: '12px', lineHeight: 1.6, marginBottom: '22px' }}>
                {useCase.description}
              </p>
            </div>

            <button 
              className="flex items-center gap-1.5 text-[#3b82f6] text-[12px] font-bold hover:gap-2.5 transition-all cursor-pointer"
              style={{ background: 'none', border: 'none', padding: 0 }}
            >
              EN SAVOIR PLUS <ArrowRight size={14} />
            </button>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default OsintUseCases;